import $api from "@/shared/http";
import { toApiError } from "@/shared/http/types";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { SelectOptionsType } from "../../model/types";

export const fetchOneDealer = createAsyncThunk(
  "dealer/fetchOneDealer",
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await $api.post("/dealer/" + id);
      if (response.status !== 200) {
        throw new Error("something gone wrong");
      } else {
        return response.data;
      }
    } catch (error) {
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const dealerfilials = createAsyncThunk(
  "dealer/dealerfilials",
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await $api.post(`/dealer/${id}/filials`);
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error("Server error: " + response.status);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const checkUpdates = createAsyncThunk(
  "dealer/checkUpdates",
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await $api.post("/dealer/" + id + "/lastupdate");
      if (response.status !== 200) {
        throw new Error("something gone wrong");
      } else {
        return response.data;
      }
    } catch (error) {
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const fetchCities = createAsyncThunk<
  SelectOptionsType[],
  void,
  { rejectValue: string }
>("dealer/fetchCities", async (_, { rejectWithValue }) => {
  try {
    const response = await $api.get<SelectOptionsType[]>("/city/items");
    return response.data;
  } catch (error) {
    const apiError = toApiError(error);
    return rejectWithValue(apiError.message);
  }
});
